import { Button as EazydraftButton, buttonVariants } from '@eazydraft/ui';
import { Loader2Icon } from 'lucide-react';
import React from 'react';

export { buttonVariants };

type ButtonProps = React.ComponentProps<typeof EazydraftButton> & {
  loading?: boolean;
};

function Button({ children, disabled, loading = false, ...props }: ButtonProps) {
  return (
    <EazydraftButton disabled={loading || disabled} {...props}>
      {loading && <Loader2Icon className="animate-spin" />}
      {children}
    </EazydraftButton>
  );
}

export { Button };
